import { Route } from '@angular/router';
import { MyPageCenterLayout } from '../pages/my-page/center/my-page-center.layout';
import { MyPageLayout } from '../pages/my-page/my-page.layout';

export const myPageRoutes: Route[] = [
  // 앱화
  // {
  //   path: 'withdraw',
  //   loadComponent: () => import('../pages/my-page/withdraw/withdraw.page'),
  // },
  // 앱화
  {
    path: 'change-contact',
    loadComponent: () =>
      import('../pages/my-page/info/change-contact/change-contact.page'),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('../pages/my-page/info/change-password/change-password.page'),
  },
  {
    path: 'change-email',
    loadComponent: () =>
      import('../pages/my-page/info/change-email/change-email.page'),
  },
  {
    path: 'update-info',
    loadComponent: () =>
      import('../pages/my-page/info/update-info/update-info.page'),
  },
  {
    path: 'my-page',
    component: MyPageLayout,
    title: '마이 페이지',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'info',
      },
      {
        path: 'info',
        loadComponent: () => import('../pages/my-page/info/my-page-info.page'),
      },
      {
        path: 'center',
        component: MyPageCenterLayout,
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'list' },
          {
            path: 'list',
            loadComponent: () =>
              import('../pages/my-page/center/list/my-page-center-list.page'),
          },
          {
            path: 'join',
            loadComponent: () =>
              import('../pages/my-page/center/join/my-page-center-join.page'),
          },
        ],
      },
      {
        path: 'payment',
        loadComponent: () =>
          import('../pages/my-page/payment/my-page-payment.page'),
      },
      {
        path: 'notification',
        loadComponent: () =>
          import('../pages/my-page/notification/my-page-notification.page'),
      },
      {
        path: 'setting',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/my-page/setting/setting.page'),
          },
          {
            path: 'notification',
            loadComponent: () =>
              import(
                '../pages/my-page/setting/notification/setting-notification.page'
              ),
          },
          {
            path: 'terms',
            loadComponent: () =>
              import('../pages/my-page/setting/terms/setting-terms.page'),
          },
          {
            path: 'sound',
            loadComponent: () =>
              import('../pages/my-page/setting/sound/setting-sound.page'),
          },
          {
            path: 'history',
            loadComponent: () =>
              import('../pages/my-page/setting/history/setting-history.page'),
          },
        ],
      },
    ],
  },
];
